// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"146":"b87f31cf","356":"79cd9549","376":"4ec42099","718":"2ef628f7"}[chunkId] + ".css";
};